import { useEffect } from "react";
import { useAuthStore } from "service";
import { queryClient } from "../query-client";
import useCreateTempRouteStore from "../state/create-temp-route-store";
import useNotificationRecipientsStore from "../state/notification-recipients-store";
import useRegionManagementStore from "../state/region-management-store";
import useRoutePlannerStore from "../state/route-planner-store";
import { clearAllStoredSearchParams } from "../utils/search-params-persistence";

const useOrganizationContextSync = (): void => {
  useEffect(() => {
    return useAuthStore.subscribe((state, prevState) => {
      // organizationId alone doesn't catch a platform super admin logging
      // out - their organizationId is already null, so it never "changes".
      // Watch the isLoggedIn falling edge too so every logout path (navbar,
      // session-expiry, cross-tab) clears the cache, not just org switches.
      const organizationChanged =
        state.organizationId !== prevState.organizationId;
      const loggedOut = prevState.isLoggedIn && !state.isLoggedIn;

      if (organizationChanged || loggedOut) {
        queryClient.clear();
        clearAllStoredSearchParams();
        useRegionManagementStore.getState().setQuery("");
        useRoutePlannerStore.getState().setQuery("");
        useNotificationRecipientsStore.getState().setQuery("");
        useCreateTempRouteStore.getState().reset();
      }
    });
  }, []);
};

export default useOrganizationContextSync;
